import { type ReactNode } from "react";
import { usePrefsStore } from "@music-app/persistence";
import { useListenAutoAdvance } from "../lib/use-listen-auto-advance.js";

/**
 * Checkbox + countdown shown in listen mode.
 *
 * Reads / writes `listenAutoAdvance` from the prefs store directly so the
 * parent drill component doesn't need to thread the pref through props.
 * Mount conditionally: `{listenMode && <ListenAutoAdvanceControl ... />}`.
 */
export function ListenAutoAdvanceControl({
  isReveal,
  onAdvance,
}: {
  isReveal: boolean;
  onAdvance: () => void;
}): ReactNode {
  const listenAutoAdvance = usePrefsStore((s) => s.listenAutoAdvance);
  const setListenAutoAdvance = usePrefsStore((s) => s.setListenAutoAdvance);
  const { secondsLeft } = useListenAutoAdvance(listenAutoAdvance, isReveal, onAdvance);

  return (
    <label className="flex items-center gap-2 mt-4 cursor-pointer select-none w-fit">
      <input
        type="checkbox"
        checked={listenAutoAdvance}
        onChange={(e) => void setListenAutoAdvance(e.target.checked)}
        className="accent-accent"
        aria-label="Auto-advance in listen mode"
      />
      <span className="font-mono text-[10px] text-inkFaded">
        {listenAutoAdvance && isReveal && secondsLeft > 0
          ? `Auto-advance · ${secondsLeft}s`
          : "Auto-advance"}
      </span>
    </label>
  );
}
